import { Typography } from "@mui/material";

interface RatingBoxProps {
    title: string;
    IconData: JSX.Element | React.ReactNode;
    count: number;
}

export const RatingBox: React.FC<RatingBoxProps> = ({ title, IconData, count }) => {
    return (
        <div className="shadow-lg flex flex-col w-full gap-3 rounded-[16px] max-w-[300px] h-full min-h-[152px] justify-center border-2 items-center">
            <Typography>{title}</Typography>
            <div className="flex justify-center items-center gap-2">
                <span>{IconData}</span>
                <span>
                    <Typography variant="h3">
                        {count.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            maximumSignificantDigits: 2
                        })}
                    </Typography>
                </span>
            </div>
        </div>
    );
};